<template>
  <div
    class="movies"
  >
    <!-- <v-layout row>
      <v-flex xs12>
        <app-header :title="title" />
      </v-flex>
    </v-layout> -->
    <app-loader v-if="loading" />

    <v-tabs
      v-model="activeTab"
      dark
      fixed-tabs
      color="teal lighten-1"
    >
      <v-tabs-slider color="yellow" />
      <v-tab
        v-for="tab in tabs"
        :key="tab.id"
      >
        <v-icon>{{ tab.icon }}</v-icon>
        <span class="pl-3">{{ tab.name }}</span>
      </v-tab>
    </v-tabs>


    <v-tabs-items v-model="activeTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.id"
        class="tab-item-element"
      >
        <template v-if="tab.category === 'now_playing'">
          <app-page-title>Des lafd grod im Kino...</app-page-title>
          <app-movie-card
            id="scrollToMe"
            :items="now_playing"
          />
          <v-container v-if="now_playing.pages !== pageNowPlaying && now_playing.movies.length !== 0">
            <v-layout row>
              <v-flex>
                <div class="text-xs-center">
                  <v-btn
                    dark
                    large
                    flat
                    :disabled="loading"
                    :loading="loading"
                    @click="loadMore(tab.category)"
                  >
                    Mehr anzeigen...
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-else-if="tab.category === 'upcoming'">
          <app-page-title>Kimd boid ins Kino...</app-page-title>
          <app-movie-card :items="upcoming" />
          <v-container v-if="upcoming.pages !== pageUpcoming && upcoming.movies.length !== 0">
            <v-layout row>
              <v-flex>
                <div class="text-xs-center">
                  <v-btn
                    dark
                    large
                    flat
                    :disabled="loading"
                    :loading="loading"
                    @click="loadMore(tab.category)"
                  >
                    Mehr anzeigen...
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-else>
          <app-page-title>Beliebte Filme</app-page-title>
          <app-movie-card :items="popular" />
          <v-container v-if="popular.pages !== pagePopular && popular.movies.length !== 0">
            <v-layout row>
              <v-flex>
                <div class="text-xs-center">
                  <v-btn
                    dark
                    large
                    flat
                    :disabled="loading"
                    :loading="loading"
                    @click="loadMore(tab.category)"
                  >
                    Mehr anzeigen...
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MovieCard from '../components/MovieCard.vue';
import PageTitle from '../components/PageTitle.vue';
// import Header from '../components/CatHeader.vue';


export default {
  name: 'Movies',
  components: {
    // appHeader: Header,
    appMovieCard: MovieCard,
    appPageTitle: PageTitle,
  },
  data() {
    return {
      activeTab: null,
      tabs: [
        {
          id: 0, name: 'Im Kino', icon: 'local_movies', category: 'now_playing',
        },
        {
          id: 1, name: 'Bald im Kino', icon: 'movie', category: 'upcoming',
        },
        {
          id: 2, name: 'Beliebt', icon: 'favorite', category: 'popular',
        },
      ],
      title: 'Im Kino',
      category: 'now_playing',
      pageNowPlaying: 1,
      pageUpcoming: 1,
      pagePopular: 1,
      offsetTop: 0,
    };
  },
  computed: {
    ...mapState({
      now_playing: state => state.quickMovieSearch.nowPlaying,
      upcoming: state => state.quickMovieSearch.upComming,
      popular: state => state.quickMovieSearch.popular,
    }),
    loading() {
      return this.$store.getters.loading;
    },
  },
  watch: {
    activeTab() {
      // console.log('activeTab Watcher called!');
      if (!this.$route.query.tab) {
        this.$router.push({ path: 'filme', query: { tab: this.activeTab } });
        return;
      }
      if (this.activeTab !== this.$route.query.tab) {
        this.$router.push({ path: 'filme', query: { tab: this.activeTab } });
        this.tabs.forEach((tab) => {
          if (tab.id === this.activeTab) {
            this.title = tab.name;
          }
        });
      }
    },
  },
  created() {
    this.init();
  },
  activated() {
    // console.log('activated called');
    if (this.$route.query.tab !== undefined) {
      if (this.$route.query.tab !== this.activeTab) {
        this.activeTab = parseInt(this.$route.query.tab, 10);
      }
    } else {
      this.$router.replace({ path: 'filme', query: { tab: 0 } });
      this.activeTab = 0;
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // console.log('before route enter called.... to tab: ', to.query.tab);
  //   if (to.query.tab === undefined) {
  //     // console.log('updating undefined route in beforeRouteEnter');
  //     next(vm => vm.$router.replace({ path: 'filme', query: { tab: 0 } }));
  //   } else {
  //     next();
  //   }
  // },
  beforeRouteUpdate(to, from, next) {
    if (to.query.tab !== this.activeTab) {
      console.log('updating active tab in beforeRouteUpdate', to.query.tab);
      this.activeTab = parseInt(to.query.tab, 10);
      // console.log('this.activeTab neu:', this.activeTab);
    }
    next();
  },
  methods: {
    loadMore(category) {
      let page;
      switch (category) {
        case 'now_playing':
          this.pageNowPlaying += 1;
          page = this.pageNowPlaying;
          break;
        case 'upcoming':
          this.pageUpcoming += 1;
          page = this.pageUpcoming;
          break;
        case 'popular':
          this.pagePopular += 1;
          page = this.pagePopular;
          break;
        default:
          page = 1;
          break;
      }
      this.$store.dispatch('getQuickMovieResults', { category, page });
    },
    init() {
      if (this.$route.query.tab === undefined) {
        this.$router.replace({ path: 'filme', query: { tab: 0 } });
      }
      this.$store.dispatch('getQuickMovieResults', { category: 'now_playing' });
      this.$store.dispatch('getQuickMovieResults', { category: 'upcoming' });
      this.$store.dispatch('getQuickMovieResults', { category: 'popular' });
    },
  },

};
</script>

<style lang="scss">

</style>
